import * as React from "react";
import { Spinner } from "components/common";
import NodeName from "views/components/messagelist/NodeName";
import usePluginEntities from "hooks/usePluginEntities";
const _inputName = (inputs, inputId) => {
  const input = inputs.get(inputId);
  return input ? /* @__PURE__ */ React.createElement("span", { style: { wordBreak: "break-word" } }, input.title) : "deleted input";
};
const FormatReceivedBy = ({
  isLocalNode,
  inputs,
  sourceInputId,
  sourceNodeId
}) => {
  var _a;
  const forwarderPlugin = usePluginEntities("forwarder");
  const ForwarderReceivedBy = (_a = forwarderPlugin == null ? void 0 : forwarderPlugin[0]) == null ? void 0 : _a.ForwarderReceivedBy;
  if (!sourceNodeId) {
    return null;
  }
  if (isLocalNode === void 0) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (isLocalNode === false) {
    return /* @__PURE__ */ React.createElement(ForwarderReceivedBy, { inputId: sourceInputId, forwarderNodeId: sourceNodeId });
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dt", null, "Received by"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("em", null, _inputName(inputs, sourceInputId)), " on ", /* @__PURE__ */ React.createElement(NodeName, { nodeId: sourceNodeId })));
};
export default FormatReceivedBy;
